import {EquivalenceCharges} from '../../../user/domain/User.model';
import {Spinner} from 'react-bootstrap';
import {ProductListUI} from '../ProductListUI';
import {OnDemandZoneUI} from '../OnDemandZoneUI';
import {HabitualesRetrasadosAviso} from './HabitualesRetrasadosAviso';

export const CartViewUI = ({
  equivalenceChargedProducts,
  equivalenceChargeFreeProducts,
  deprecatedProducts,
  equivalenceCharges,
  loading
}) => {
  if (loading === true) {
    return <Spinner className="text-center" />;
  }

  // Lineas con precio tocado por el comercial (solo en modo comercial con permiso): aviso rojo arriba
  const lineasConPrecioModificado = [
    ...(equivalenceChargedProducts ?? []), ...(equivalenceChargeFreeProducts ?? []), ...(deprecatedProducts ?? [])
  ].filter(p => p.precioModificado === true).length;

  return (
    <>
      {lineasConPrecioModificado > 0 && (
        <div className="alert alert-danger fw-bold" role="alert" data-testid="aviso-precio-modificado">
          Este pedido lleva {lineasConPrecioModificado === 1 ? '1 línea' : `${lineasConPrecioModificado} líneas`} con precio modificado por el comercial. BC recibirá el aviso en observaciones comerciales.
        </div>
      )}
      {
        deprecatedProducts?.length > 0 && (
          <div className="mb-3">
            <div className="mb-2">
              <h4>Productos desactualizados</h4>
              <small className="text-danger">Borra o edita estos productos para tramitar el pedido</small>
            </div>
            <ProductListUI products={deprecatedProducts} areDeprecated />
          </div>
        )
      }
      <div>
        <h4>Productos en tu carrito</h4>
        {
          equivalenceCharges === EquivalenceCharges.YES && <ProductListUI products={equivalenceChargedProducts} splitOnDemand />
        }
        {
          equivalenceCharges === EquivalenceCharges.NO && <ProductListUI products={equivalenceChargeFreeProducts} splitOnDemand />
        }
        {
          equivalenceCharges === EquivalenceCharges.BY_CHOICE && (
            <>
              <p>
                Tu carrito contiene productos <a href="#equivalence-charge-free-products">sin recargo de equivalencia</a> y <a href="#equivalence-charged-products">con recargo de
                equivalencia</a>
              </p>
              <div className="d-flex flex-column gap-5">
                <div id="equivalence-charge-free-products">
                  <p className="fw-bold">
                    Productos <b>SIN</b> recargo de equivalencia ({equivalenceChargeFreeProducts?.length})
                    <br />
                    <a href="#equivalence-charged-products" className="text-muted">
                      Ir a pedidos <b>CON</b> recargo de equivalencia
                    </a>
                  </p>
                  <ProductListUI products={equivalenceChargeFreeProducts} splitOnDemand />
                </div>
                <div id="equivalence-charged-products">
                  <p className="fw-bold">
                    Productos <b>CON</b> recargo de equivalencia ({equivalenceChargedProducts?.length})
                    <br />
                    <a href="#equivalence-charge-free-products" className="text-muted">
                      Ir a pedidos <b>SIN</b> recargo de equivalencia
                    </a>
                  </p>
                  <ProductListUI products={equivalenceChargedProducts} splitOnDemand />
                </div>
              </div>
            </>
          )
        }
        <OnDemandZoneUI products={visibleProducts(equivalenceCharges, equivalenceChargedProducts, equivalenceChargeFreeProducts)} />
      </div>
      {/* Solo con lineas en el carrito; justo antes del resumen y el boton de confirmar de Checkout */}
      {visibleProducts(equivalenceCharges, equivalenceChargedProducts, equivalenceChargeFreeProducts).length > 0 && <HabitualesRetrasadosAviso />}
    </>
  );
};

// Las líneas que participan en el pedido según el modo de recargo de equivalencia:
// la zona "Bajo pedido" solo debe recoger excesos de líneas que se están enseñando.
const visibleProducts = (equivalenceCharges, charged = [], free = []) => {
  if (equivalenceCharges === EquivalenceCharges.YES) {
    return charged ?? [];
  }
  if (equivalenceCharges === EquivalenceCharges.NO) {
    return free ?? [];
  }
  return [...(free ?? []), ...(charged ?? [])];
};